<template>
  <div class="tv-stations__wrapper">
      <div class="container">
          <div class="columns">
              <div class="column" v-for="(item, key) in stations" :key="key">
                  <a :href="item.url" target="_blank" class="tv-stations__item">
                      <img :src="getStationsImage(item.image.file_name)" :alt="item.image.alt">
                  </a>
              </div>
          </div>
      </div>
  </div>
</template>

<script setup>

const getStationsImage = name => new URL(`/src/assets/images/stations/${name}`, import.meta.url).href;

const stations = [
    {
        title: "TVP1",
        url:"https://tvp1.tvp.pl",
        image: {
            title: "tvp1",
            alt:null,
            file_name: "tvp1.svg"
        }
    },
    {
        title: "TVP2",
        url: "https://tvp2.tvp.pl",
        image: {
            title: "tvp2",
            alt: null,
            file_name: "tvp2.svg",
        }
    },
    {
        title: "TVP3",
        url: "https://regiony.tvp.pl",
        image: {
            title: "tvp3",
            alt: null,
            file_name: "tvp3.svg",
        }
    },
    {
        title:"TVP ABC",
        url:"https://abc.tvp.pl",
        image: {
            title:"tvp abc",
            alt:null,
            file_name:"tvpabc.svg",
        }
    },
    {
        title: "TVP Kultura",
        url: "https://tvpkultura.tvp.pl",
        image: {
            title: "tvp kultura",
            alt: null,
            file_name: "tvpkultura.svg",
        }
    },
    {
        title: "TVP Historia",
        url: "https://historia.tvp.pl",
        image: {
            title:"tvp historia",
            alt:null,
            file_name:"tvphistoria.svg"
        }
    },
    {
        title: "TVP Sport",
        url:"https://sport.tvp.pl",
        image: {
            title:"tvp sport",
            alt:null,
            file_name:"tvpsport.svg",
        }
    },
    {
        title:"TVP INFO",
        url:"https://www.tvp.info",
        image: {
            title:"tvp info",
            alt:null,
            file_name:"tvpinfo.svg",
        }
    },
    {
        title:"TVP Kobieta",
        url:"https://kobieta.tvp.pl",
        image: {
            title:"tvp kobieta",
            alt:null,
            file_name:"tvpkobieta.svg",
        }
    },
    {
        title:"TVP Polonia",
        url:"https://polonia.tvp.pl",
        image: {
            title:"tvp polonia",
            alt:null,
            file_name:"tvppolonia.svg",
        }
    },
    {
        title: "TVP Rozrywka",
        url: "https://rozrywka.tvp.pl",
        image: {
            title:"tvp rozrywka",
            alt:null,
            file_name:"tvprozrywka.svg",
        }
    },
    {
        title:"TVP Dokument",
        url:"https://dokument.tvp.pl",
        image: {
            title:"tvp dokument",
            alt:null,
            file_name:"tvpdokument.svg",
        }
    },
    {
        title:"TVP Seriale",
        url:"https://seriale.tvp.pl",
        image: {
            title:"tvp seriale",
            alt:null,
            file_name:"tvpseriale.svg"
        }
    },
    {
        title:"TVP HD",
        url:"https://hd.tvp.pl",
        image: {
            title:"tvp hd",
            alt:null,
            file_name:"tvphd.svg",
        }
    },
    {
        title:"TVP Wilno",
        url:"https://wilno.tvp.pl",
        image: {
            title:"tvp wilno",
            alt:null,
            file_name:"tvpwilno.svg"
        }
    },
    {
        title:"TVP Parlament",
        url:"https://www.tvpparlament.pl",
        image: {
            title:"tvp parlament",
            alt:null,
            file_name:"tvpparlament.svg"
        }
    },
    {
        title:"TVP World",
        url:"https://tvpworld.com",
        image: {
            title:"tvp world",
            alt:"tvp world",
            file_name:"tvpworld.svg",
        }
    },
    {
        title:"TVP Bie\u0142sat",
        url:"https://belsat.eu/pl",
        image: {
            title:"tvp bielsat",
            alt:"tvp bielsat",
            file_name:"belsat.svg"
        }
    },
    {
        title:"TVP ABC 2",
        url:"https://stream.tvp.pl/?channel_id=51466516",
        image: {
            title:"tvp abc 2",
            alt:null,
            file_name:"tvpabc2.svg"
        }
    },
    {
        title:"TVP Kultura 2",
        url:"https://kultura2.tvp.pl",
        image: {
            title:"tvp kultura 2",
            alt:null,
            file_name:"tvpkultura2.svg"
        }
    },
    {
        title:"TVP Historia 2",
        url:"https://historia.tvp.pl/52614342/historia2",
        image: {
            title:"tvp historia 2",
            alt:null,
            file_name:"tvphistoria2.svg",
        }
    },
    {
        title:"TVP Nauka",
        url:"https://nauka.tvp.pl",
        image: {
            title:"tvp nauka",
            alt:null,
            file_name:"tvpnauka.svg"
        }
    },
    {
        title:"TVP Alfa",
        url:"https://stream.tvp.pl/?channel_id=56969941",
        image:{
            title:"tvp alfa",
            alt:"tvp alfa",
            file_name:"tvpalfa.svg"
        }
    }]
</script>

<style lang="scss">
@import "@/assets/scss/components/elements/tv-stations-logo-footer.scss";
</style>